export class Email {
    count: number
    rows : ListEmail[];

    constructor () {
        this.count = 0;
        this.rows = [];
    }
}
export class ListEmail {
    id: number;
    subject: string;
    send_to: any;
    reply_to: any;
    content: any;
    email_type: string;
    created_by: any;    
}
export class EmailFilter {
    subject: string;
    send_to: any;
    email_type: any;
    limit: number;
    page: number
    constructor() {
        this.email_type = 0;
        this.page = 1;
        this.limit = 50;
    }
}
export class SendEmail {
    subject: string;
    reply_to: string;
    content: string;
    student_ids: any;
}
export class SaveEmail {
    id: number;
    subject: string;
    send_to: string;
    reply_to: string;
    content: string;
    email_type: any;
}
export class EmailStudentsFilter {
    programme_type: any;
    schoolYear: number;
    campusId: any;
    classId: any;
    nationality: any;
    isBus: any;
    tuitionStatus: any;
    limit: number;
    page: number
    constructor() {
        this.programme_type = 0;
        this.schoolYear = 0;
        this.campusId = 0;
        this.classId = 0;
        this.isBus = 0;
        this.tuitionStatus = '';
    }
}

export class JobSendMail {
    id?: number;
    status: boolean;
    content: any;
    constructor(){
        this.status = true;
        this.content = { day_interval: null }
    }
}



// WEBPACK FOOTER //
// ./src/holiday/models/Email.ts